var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WearWeldingMask50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35,16c0-3.866-3.134-7-7-7h-8c-3.866,0-7,3.134-7,7v12.635c0,6.057,4.738,11.252,10.794,11.363 C29.963,40.111,35,35.144,35,29V16z M17,17h14v7H17V17z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14,22h-2c-0.552,0-1-0.448-1-1v-1c0-0.552,0.448-1,1-1h2V22z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34,19h2c0.552,0,1,0.448,1,1v1c0,0.552-0.448,1-1,1h-2V19z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WearWeldingMask50);
export default __webpack_public_path__ + "static/media/icons8-wear-welding-mask-50.18d3ffeb1207ccb0ea17db9edead8a12.svg";
export { ForwardRef as ReactComponent };